import { replaceWhitespace } from '../../../utils';

export const buildErrorId = ({ errorText, name, namespace }) => {
  if (!errorText) return '';
  const msg = Array.isArray(errorText) ? errorText.join(' ') : errorText;
  return [namespace, name, replaceWhitespace(msg)].filter(Boolean).join('_');
};

// extract the error message based on the meta object, passed down by the Field component.
export const getError = ({
  error,
  modifiedSinceLastSubmit,
  submitError,
  touched,
}) => {
  if (!modifiedSinceLastSubmit && submitError) return submitError;
  return !touched ? null : error || submitError;
};

export const flattenOptions = (options) =>
  options.length && 'options' in options[0]
    ? options.flatMap((group) => group.options)
    : options;

// A function that help us keep the form state consistent after
// programatic value changes.
// In some cases we have to normalize the provided value (editor component),
// or set the default value ourselves (location select in publication form),
// but we don't want any side-effects that go with making a change
// to a form field (making form touched, dirty...).
export const normalizeInitialValue = ({
  form,
  value,
  name,
  isEqual = (a, b) => a === b,
}) => {
  const { touched, initialValues } = form.getState();
  // we have to calculate our own pristine since some fields are
  // formated automatically making fields `ditrty` in form context
  const pristine = Object.values(touched).every((isToched) => !isToched);

  // if the form is not touched by the user and the initial value
  // of the given field is different from the normalized value we
  // reinitialize the form with the normalized value, making it
  // not dirty, aka pristine again in the Form context
  if (pristine && !isEqual(initialValues[name], value)) {
    form.reset({ ...initialValues, [name]: value });
  }
};

export const INPUT_TYPE = {
  INTEGER: 'integer',
  LINK: 'link',
  TEXTAREA: 'textarea',
  TEXT: 'text',
  NUMBER: 'number',
};
